import { useTranslation } from 'react-i18next';

export default function CarierPlaceholder({name = "", brief=""}){
  const { t } = useTranslation();
  return (
    <div class="flex justify-center p-4 mx-8 ">
        <div class="bg-white bg-opacity-90 backdrop-blur-md rounded-xl shadow-md mt-8 max-w-5xl w-full overflow-hidden border border-gray-200 ring-1 ring-gray-100 transition-all duration-300">

            <p class="p-6 text-xl whitespace-pre-wrap content-center bg-white bg-white bg-opacity-95">
              {t("carier_pl_holder")}<a href={"mailto:feilhauer.m@sefos.cz"} className={"font-bold hover:text-orange-700 text-orange-900 underline"}>feilhauer.m@sefos.cz</a> {t("carier_pl_holder_af_mail")} <span className={"font-bold text-orange-950 "}>+420 732 988 303</span>
            </p>
        </div>

    </div>
  );

};